module.exports = __webpack_public_path__ + "static/media/self_ca.7e6bf775.png";